/**
 * Utility
 *
 * A bunch of utility functions thats useful for the site
 *
 * @requires jQuery
 * @author Chris Li
 */

/**
 * loader
 *
 * Used to display a loading graphic on the page.  Best for use with ajax calls
 * @example loader.init('have-bg');  //if you want to have a loading background, initialize
 * this, and a div with class 'loader_bg' will be created.
 * @example loader.showLoader('window'); //loads on the entire window and centers
 *          on the page about 1/3 of the way down from the top
 * @example loader.showLoader('#some-element');  //if you have a modal window, best
 *          to use this to load into the window for loading.
 * @example loader.hideLoader();
 * @type class
 *
 */
var loader = {
    elem: '',
    elem_top: '0',
    elem_left: '0',
    loader_bg: 'none',
    init: function(loader_bg) {
        "use strict";
        if (typeof(loader_bg) != 'undefined') {
            loader.loader_bg = loader_bg;
        }
    },
    appendLoader: function() {
        "use strict";
        if (loader.elem != '') {
            loader.elem_top = $(loader.elem).position().top;
            loader.elem_left = $(loader.elem).position().left;
            if (loader.loader_bg == 'none') {
                var html_loader = '<div class="loader">' +
                        '<i class="fa fa-refresh fa-spin"></i>' +
                        '<div class="loader_text"></div>' +
                    '</div>';
            } else {
                var the_height = $(window).height();
                var html_loader = '<div class="loader_bg" style="display:absolute; width:100%; height: '+the_height+'px;"></div><div class="loader">' +
                        '<i class="fa fa-refresh fa-spin"></i>' +
                        '<div class="loader_text"></div>' +
                    '</div>';
            }
            $(loader.elem).append(html_loader);

            //position element
            //$(loader.elem).height()
            $('.loader').css({
                top: loader.elem_top + ($(window).height() / 2.5),
                left: "48%"
            });
        } else {
            throw new Error("appendLoader(): Oops.  You need to include an element that the loader will be attached to.");
        }
    },
    showLoader: function(elem) {
        "use strict";
        loader.elem = elem;
        loader.appendLoader(loader.elem);
        $('.loader').fadeIn(300);
    },
    hideLoader: function() {
        "use strict";
        $('.loader').fadeOut(300, function() {
            loader.removeLoader();
        });
    },
    removeLoader: function() {
        "use strict";
        if (loader.loader_bg != 'none') {
            $('.loader_bg').remove();
        }
        $('.loader').remove();
    }
};

/**
 * ajaxAlert
 *
 * Using hidden divs to hold error and success messages.  Helping them
 * display on page.
 *
    used in conjunction with message.php
 *
 *
 * @example
 *      ajaxAlert.init('.success-message', '.failure-message', '.text');
        ajaxAlert.init( 'class or id of success container',
                        'class or id of error container',
                        'class of text container');
        ajaxAlert.showAlert('The message of the alert.', 'success | failure', 'position in px for scroll to error. i.e. 0px');
 *
 * @type class
 *
 */
var ajaxAlert = {
    c_success: null,
    c_error: null,
    c_text: null,
    init: function(success_container, error_container, text_container) {
        success_container = (typeof(success_container) == 'undefined') ? '.success-message' : success_container;
        error_container = (typeof(error_container) == 'undefined') ? '.failure-message' : error_container;
        text_container = (typeof(text_container) == 'undefined') ? '.text' : text_container;

        ajaxAlert.c_success = success_container;
        ajaxAlert.c_error = error_container;
        ajaxAlert.c_text = text_container;
    },
    checkInit: function() {
        if ($(ajaxAlert.c_success) == 'undefined' ||
            $(ajaxAlert.c_error) == 'undefined' ||
            $(ajaxAlert.c_text) == 'undefined') {
            alert('One of the alert containers is undefined');
            return false;
        } else {
            ajaxAlert.resetAlert();
            return true;
        }
    },
    //the type = success | error
    //scroll_up = true | false
    showAlert: function(the_message, the_type, scroll_pos) {
        if (ajaxAlert.checkInit()) {
            the_message = typeof the_message !== 'undefined' ? the_message : (the_type == 'success') ? 'Success!' : 'Error.';
            the_type = typeof the_type !== 'undefined' ? the_type : 'success';

            if (typeof scroll_pos == 'string') {
                posObj = $(scroll_pos);
                if (typeof posObj == 'undefined') {
                    scroll_pos = 0;
                } else {
                    scroll_pos = $(scroll_pos).offset().top;
                }
            } else {
                scroll_pos = typeof scroll_pos !== 'undefined' ? scroll_pos : 0;
            }

            if (the_type == 'success') {
                $(ajaxAlert.c_success + ' ' + ajaxAlert.c_text).html(the_message);
                $(ajaxAlert.c_success).fadeIn();
            } else {
                $(ajaxAlert.c_error + ' ' + ajaxAlert.c_text).html(the_message);
                $(ajaxAlert.c_error).fadeIn();
            }

            if (typeof(scroll_pos) != 'undefined') {
                $("html, body").animate({
                    scrollTop: scroll_pos
                }, 200);
            }
        }
    },

    resetAlert: function() {
        $(ajaxAlert.c_success + ' ' + ajaxAlert.c_text).html('');
        $(ajaxAlert.c_success).hide();
        $(ajaxAlert.c_error + ' ' + ajaxAlert.c_text).html('');
        $(ajaxAlert.c_error).hide();
    }
};

/**
 *  BrowserDetect.browser == 'Explorer';
    BrowserDetect.version <= 9;
 * @type type
 */
var BrowserDetect = {
    init: function ()
    {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) ||       this.searchVersion(navigator.appVersion) || "Unknown";
    },

    searchString: function (data)
    {
        for (var i=0 ; i < data.length ; i++)
        {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) != -1)
            {
                return data[i].identity;
            }
        }
    },

    searchVersion: function (dataString)
    {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
    },

    dataBrowser:
    [
        { string: navigator.userAgent, subString: "Chrome",  identity: "Chrome" },
        { string: navigator.userAgent, subString: "MSIE",    identity: "Explorer" },
        { string: navigator.userAgent, subString: "Trident", identity: "Explorer" },
        { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
        { string: navigator.userAgent, subString: "Safari",  identity: "Safari" },
        { string: navigator.userAgent, subString: "Opera",   identity: "Opera" }
    ]
};

BrowserDetect.init();

function getURLParameter(name, text) {
    "use strict";
    var _location = (typeof(text) != 'undefined') ? text : location.search;
    return decodeURI(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(_location) || [, null])[1]
    );
}


$(document).ready(function() {
    "use strict";
    loader.init();
});
